<template>
  <Modal ref="modalRef" small ok-text="Add card" :ok-disabled="!personIdRef.trim()" busy-text="Adding…" @shown="onShown" @ok="onOk">
    <template #title>New card</template>
    <label class="person-id">
      <span>Person id</span>
      <input type="text" ref="inputRef" v-model.trim="personIdRef" placeholder="e.g. K26X-V71" autocomplete="off" spellcheck="false"/>
    </label>
  </Modal>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue'
import Modal from '@/util/Modal.vue'

const emit = defineEmits<{
  (e: 'add', personId: string): void
}>()

// The parent drives the modal (open/close/reset) and does the FS read + addCardInfo,
// so it stays busy while the parent works and can reopen on failure.
defineExpose({
  open: () => modalRef.value?.open(),
  close: () => modalRef.value?.close(),
  reset: () => modalRef.value?.reset(),
})

const personIdRef = ref('')

const modalRef = ref<InstanceType<typeof Modal>>()
const inputRef = ref<HTMLInputElement>()

async function onShown() {
  personIdRef.value = ''
  await nextTick()
  inputRef.value?.focus()
}

function onOk() {
  emit('add', personIdRef.value.trim())
}
</script>

<style lang="scss" scoped>
.person-id {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;

  input {
    font-size: 0.875rem;
  }
}
</style>
